(function () {
  function amount(track) {
    var card = track.querySelector('.meet-bestseller__track-item');
    if (!card) return track.clientWidth * 0.85;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 14;
    return card.getBoundingClientRect().width + gap;
  }

  function initTrack(track) {
    if (!track || track.dataset.hscroll) return;
    track.dataset.hscroll = '1';

    var wrap = document.createElement('div');
    wrap.className = 'meet-bestseller__hscroll';
    track.parentNode.insertBefore(wrap, track);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'meet-bestseller__hscroll-btn meet-bestseller__hscroll-btn--prev';
    prev.setAttribute('aria-label', 'Previous ingredients');
    prev.innerHTML = '&larr;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'meet-bestseller__hscroll-btn meet-bestseller__hscroll-btn--next';
    next.setAttribute('aria-label', 'Next ingredients');
    next.innerHTML = '&rarr;';

    var nav = document.createElement('div');
    nav.className = 'meet-bestseller__hscroll-nav';
    nav.appendChild(prev);
    nav.appendChild(next);

    wrap.appendChild(track);
    wrap.appendChild(nav);

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(track), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(track), behavior: 'smooth' });
    });

    function update() {
      var canScroll = track.scrollWidth - track.clientWidth > 4;
      wrap.classList.toggle('is-scrollable', canScroll);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 300);
  }

  function resetTrack(track) {
    if (!track) return;
    delete track.dataset.hscroll;
    if (track.parentElement && track.parentElement.classList.contains('meet-bestseller__hscroll')) {
      var wrap = track.parentElement;
      wrap.parentNode.insertBefore(track, wrap);
      wrap.remove();
    }
  }

  function initSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-mb-slider]').forEach(function (track) {
      resetTrack(track);
      initTrack(track);
    });
  }

  function initSection(root) {
    if (!root.dataset.mbReady) {
      root.dataset.mbReady = '1';

      var modal = root.querySelector('[data-mb-modal]');
      if (modal) {
        function openModal() {
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
        }

        function closeModal() {
          modal.hidden = true;
          document.body.style.overflow = '';
        }

        root.querySelectorAll('[data-mb-open]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            openModal();
          });
        });

        modal.addEventListener('click', function (event) {
          if (event.target === modal || event.target.hasAttribute('data-mb-close')) {
            closeModal();
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
          }
        });
      }
    }

    initSliders(root);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-meet-bestseller]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
